import { z } from 'zod';
import { lowercasedRequiredUuidString } from './lowercased-required-uuid-string.js';
import { MAX_TRANSFER_ORDER_PICK_RETURNS_PER_REQUEST } from './max-transfer-order-pick-returns-per-request.js';
import { returnTransferOrderPickDrawEntryInputSchema } from './return-pick-draw-entry-input.js';
export const returnTransferOrderPickDrawInputSchema = z
    .object({
    transferOrderId: lowercasedRequiredUuidString('Transfer order id is required.', 'Invalid transfer order id.'),
    returns: z
        .array(returnTransferOrderPickDrawEntryInputSchema)
        .min(1, 'Choose at least one pick to return.')
        .max(MAX_TRANSFER_ORDER_PICK_RETURNS_PER_REQUEST, `Return at most ${MAX_TRANSFER_ORDER_PICK_RETURNS_PER_REQUEST} picks at a time.`),
})
    .superRefine((values, context) => {
    const pickItemIds = values.returns.map((entry) => entry.pickItemId);
    if (new Set(pickItemIds).size !== pickItemIds.length) {
        context.addIssue({
            code: 'custom',
            path: ['returns'],
            message: 'Each pick can be returned once.',
        });
    }
});
//# sourceMappingURL=return-pick-draw-input.js.map